<template>
  <div class="py-3 px-5">
          <img src="https://ipssoma.com/img/logo-aula.6519c613.png">
          <h2 class="text-center">Registro de usuario</h2>
  </div>
</template>
<script>
export default {
  data() {
    return {
      form: {
        user: "",
        phone: "",
        email: "",
        message: "",
      },
    };
  },
  methods: {},
};
</script>

